import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import BaseError from 'utils/base-error';
import { fetchAwardsThunk, useAppSelector } from 'shared';
// eslint-disable-next-line no-restricted-imports
import { fetchCompanyInformationThunk } from 'shared/lib';

export const AppDataProcessActions = {
    fetchAwards: createAsyncThunk(
        'AppDataProcessActions.fetchAwards',
        async () => fetchAwardsThunk(),
    ),
};

export type AppDataProcessState = {
    loaded: boolean
    errors: BaseError[]
    backgroundUrl?: string
    defaultDeliveryFIlter?: string
    seasonOffer?: {
        title: string,
        link: string,
    }
};

const initialState: AppDataProcessState = {
    loaded: false,
    errors: [],
};

export const appDataProcessSlice = createSlice({
    name: 'appDataProcessSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            AppDataProcessActions.fetchAwards.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // console.log('appDataProcessSlice', response);
                }
                state.loaded = true;
            },
        );
        builder.addCase(
            fetchCompanyInformationThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    console.log(response.data.data.background?.url);
                    state.backgroundUrl = response.data.data.background?.url;
                    state.defaultDeliveryFIlter = (
                        response.data.data.defaultDeliveryFIlter || undefined
                    );
                    if (response.data.data.seasonOffer) {
                        state.seasonOffer = {
                            title: response.data.data.seasonOffer.title,
                            link: response.data.data.seasonOffer.link,
                        };
                    }
                }
            },
        );
    },
});

export const useAppDataProcessState = () => useAppSelector((store) => store.appDataProcess);
